import React, { useEffect, useState } from 'react';
import authApi from '../../api/auth';
import { BACK_ARROW } from '../../assets/icons';

interface IloginStep {
  onVerify: (otp: number) => void;
  email: string;
  setOtpSend: any;
}

const OtpScreen: React.FC<IloginStep> = ({ onVerify, email, setOtpSend }) => {
  const [OTP, setOTP] = useState({ otp1: '', otp2: '', otp3: '', otp4: '' });
  const [seconds, setSeconds] = useState(30);
  const [showResend, setShowResend] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const handleOTPInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOTP({ ...OTP, [e.target.name]: e.target.value });
  };

  const inputfocus = (elmnt: any) => {
    if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {
      const next = elmnt.target.tabIndex;
      if (next < 4) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  const resendEmail = () => {
    if (seconds > 0) {
      return;
    }
    authApi
      .sendOtp(email)
      .then((result) => {
        if (result) {
          setShowResend(false);
        }
      })
      .catch((err) => err);
  };

  const onSubmit = () => {
    let otp = Object.values(OTP).join('');
    onVerify(Number(otp));
  };
  return (
    <div className="flex flex-col justify-center items-center md:mt-14">
      <div className="flex flex-col w-full justify-between lg:gap-0 gap-6">
        <img src={BACK_ARROW} alt="" className="w-5 cursor-pointer" onClick={() => setOtpSend(false)} />
        <h5 className="text-black text-left md:text-center text-2xl md:text-xl font-semibold w-full">Verify Email</h5>
        <p className="w-full pt-4 md:pt-10 text-neutralGray2 text-left">
          A verification code has been sent to your Email ID
        </p>
        <div className="flex flex-col w-full justify-center items-start mb-4">
          <p className="w-full py-6 text-base font-medium text-left">Enter OTP</p>
          <form>
            <input
              name="otp1"
              type="tel"
              autoComplete="off"
              className="w-14 md:w-20 h-14 border border-neutralBlue1 bg-white rounded-md mr-4 text-lg font-semibold text-center"
              value={OTP.otp1}
              onChange={(e) => handleOTPInput(e)}
              tabIndex={1}
              maxLength={1}
              onKeyUp={(e) => inputfocus(e)}
            />
            <input
              name="otp2"
              type="tel"
              autoComplete="off"
              className="w-14 md:w-20 h-14 border border-neutralBlue1 bg-white rounded-md mr-4 text-lg font-semibold text-center"
              value={OTP.otp2}
              onChange={(e) => handleOTPInput(e)}
              tabIndex={2}
              maxLength={1}
              onKeyUp={(e) => inputfocus(e)}
            />
            <input
              name="otp3"
              type="tel"
              autoComplete="off"
              className="w-14 md:w-20 h-14 border border-neutralBlue1 bg-white rounded-md mr-4 text-lg font-semibold text-center"
              value={OTP.otp3}
              onChange={(e) => handleOTPInput(e)}
              tabIndex={3}
              maxLength={1}
              onKeyUp={(e) => inputfocus(e)}
            />
            <input
              name="otp4"
              type="tel"
              autoComplete="off"
              className="w-14 md:w-20 h-14 border border-neutralBlue1 bg-white rounded-md mr-4 text-lg font-semibold text-center"
              value={OTP.otp4}
              onChange={(e) => handleOTPInput(e)}
              tabIndex={4}
              maxLength={1}
              onKeyUp={(e) => inputfocus(e)}
            />
          </form>
        </div>
        {showResend && (
          <p
            onClick={() => resendEmail()}
            className={`my-4 md:mt-24 text-center text-sm font-medium ${
              seconds === 0 ? 'text-primaryPink cursor-pointer hover:underline' : 'text-neutralGray1'
            }`}
          >
            {`Resend OTP ${seconds ? `(${seconds}s)` : ''}`}
          </p>
        )}
        <button
          onClick={() => onSubmit()}
          className="my-6 w-full h-12 bg-secondary rounded-full text-white text-base font-medium"
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default OtpScreen;
